import * as request from '../utils/request'

export function logout (param) {
  return request.post('logout', '1.0.0.0', param)
}
